import React from "react";
import {
  Box,
  Typography,
  Container,
  Grid,
  Paper,
  useMediaQuery,
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import {
    blackShade05,
  blackShade19,
  blueColor04,
  greyColor40,
  greyShade05,
  logoImgborder1,
  whiteColor,
  yellowShade03,
} from "../../configs/styles/muiThemes";
import StyledSwitch from "../../components/Switch/StyledSwitch";

const AffiliateMarketingBenefits = () => {
  return (
    <Box sx={{ pt: { xs: 1, md: 0 } }}>
      <Typography
        variant="h4"
        color={blackShade05}
        fontSize={{ xs: 15, md: 17 }}
        fontWeight="600"
        m={{xs:'15px 0 3px', md:"24px 0 3px"}}
      >
        Affiliate Panel
      </Typography>

      <AffiliateInfoCard />

      <Box mt="25px">
        <Typography
          fontSize={22}
          fontWeight="600"
          color={blackShade19}
          textAlign="center"
          m="10px 0 20px"
        >
          Benefits Affiliate Marketing
        </Typography>

        <Grid container spacing={3}>
          {/* Left Side Banner */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                ...styles.imgBgBox,
                backgroundImage:
                  "url(https://storage.googleapis.com/bodefaults/businessdashboardweb/affiliate-empty-bg-1.jpg)",
              }}
            >
              <Typography
                fontSize={14}
                fontWeight={600}
                color="white"
                sx={{ textShadow: "2px 2px #000000", pb: "5px" }}
              >
                Increase sales by 10x
              </Typography>
              <Typography
                fontSize={20}
                fontWeight={600}
                color="white"
                lineHeight="30px"
                sx={{ textShadow: "2px 2px #000000", mt: "4px" }}
              >
                <Typography
                  component="span"
                  sx={{ color: yellowShade03, fontSize: 20, fontWeight: "600" }}
                >
                  Unleash the Magic of
                </Typography>{" "}
                Affiliate Marketing, <br />
                Right Now!
              </Typography>
            </Box>
          </Grid>

          {/* Right Side Banner */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                ...styles.imgBgBox,
                backgroundImage:
                  "url(https://storage.googleapis.com/bodefaults/businessdashboardweb/affiliate-empty-bg-2.jpg)",
                backgroundSize: "70%",
                backgroundPosition: "100% 10%",
              }}
            >
              <Typography
                fontSize={14}
                fontWeight={600}
                color={whiteColor}
                sx={{ textShadow: "2px 2px #000000", pb: "5px" }}
              >
                More Reach . More Sales . More Profits
              </Typography>
              <Typography
                fontSize={20}
                fontWeight={600}
                color={whiteColor}
                lineHeight="30px"
                sx={{ textShadow: "2px 2px #000000", mt: "4px" }}
              >
                Turn your{" "}
                <Typography
                  component="span"
                  sx={{ color: yellowShade03, fontSize: 20, fontWeight: "600" }}
                >
                  Customers into Influencers
                </Typography>{" "}
                <br />
                Today!
              </Typography>
            </Box>
          </Grid>

          {/* Image Placeholder */}
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="https://storage.googleapis.com/bodefaults/businessdashboardweb/affiliates-empty-flow.png"
              sx={{ width: "100%" }}
            />
          </Grid>

          {/* Benefits Section */}
          <Grid item xs={12} md={6}>
            <Typography
              fontSize={22}
              fontWeight={600}
              color={blackShade19}
              lineHeight="32px"
              mb="15px"
            >
              Measure & GROW your ROI of Digital Investments
            </Typography>

            <Typography
              fontSize={14}
              fontWeight={500}
              color={blueColor04}
              lineHeight="22px"
              mb="6px"
            >
              Are you spending too much on{" "}
              <Typography
                component="span"
                fontSize={14}
                fontWeight={600}
                color={yellowShade03}
                sx={{ textDecoration: "underline" }}
              >
                Digital Promotions
              </Typography>{" "}
              without any results?
            </Typography>

            <Typography
              fontSize={14}
              fontWeight={500}
              color={blueColor04}
              lineHeight="22px"
              mb="6px"
            >
              Would you like to{" "}
              <Typography
                component="span"
                fontSize={14}
                fontWeight={600}
                color={yellowShade03}
                sx={{ textDecoration: "underline" }}
              >
                grow your affiliate network
              </Typography>{" "}
              and reach more potential <br /> customers?
            </Typography>

            <Typography
              fontSize={16}
              fontWeight={600}
              color={blackShade19}
              lineHeight="22px"
              mb="6px"
              sx={{ mt: "24px", mb: "12px" }}
            >
              We got you covered!
            </Typography>

            <Grid container spacing={0}>
              <Grid item xs={12} md={7}>
                {[
                  "Affiliate enrollment from you Brand website",
                  "Success Fee based model, Direct Settlements",
                  "Employee Referral Programs",
                ].map((text, index) => (
                  <ListItem key={index} text={text} />
                ))}
              </Grid>

              <Grid item xs={12} md={5}>
                {[
                  "Social Media Sales Tracking",
                  "Affiliate performance monitoring",
                  "Performance based commissions",
                ].map((text, index) => (
                  <ListItem key={index} text={text} />
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default AffiliateMarketingBenefits;

const AffiliateInfoCard = () => {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));
  return (
    <Box sx={styles.infoBox}>
      <Box sx={{ flex: 1, display: "flex", alignItems: "center", gap: 0.5 }}>
        <Box mt={-0.5}>
          <StyledSwitch
            isChecked={false}
            onChange={() => {}}
            gap={0.3}
            labelFontSize={matches ? 14 : 12.5}
            labelFontWeight={600}
          />
        </Box>

        <Typography
          fontSize={{xs:12, md: 13}}
          fontWeight={400}
          color={greyColor40}
          lineHeight={{xs:'18px', md:"15px"}}
        >
          Affiliate marketing is not enabled for your business. To enable it,
          please contact{" "}
          <Typography
            component="span"
            fontSize={{xs:12, md: 13}}
            fontWeight={500}
            color={blueColor04}
            lineHeight={{xs:'18px', md:"15px"}}
          >
            support@costbo.com
          </Typography>
        </Typography>
      </Box>
    </Box>
  );
};

const ListItem = ({ text }) => {
  return (
    <Box display="flex" alignItems="center" gap={1} mb="10px">
      <Box
        sx={{
          width: "3.5px",
          height: "3.5px",
          borderRadius: "5px",
          bgcolor: greyShade05,
        }}
      ></Box>

      <Typography
        sx={{
          flex: 1,
          fontSize: 13,
          fontWeight: 500,
          lineHeight: "23px",
          color: greyShade05,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

const styles = {
  imgBgBox: {
    position: "relative",
    height: 175,
    borderRadius: "14px",
    color: "white",
    p: "10px 20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    overflow: "hidden",
    backgroundSize: "50%",
    backgroundPosition: "100% 46%",
    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      borderRadius: "14px",
      background: "linear-gradient(to right, #0c1831 50%, #02b5ff00 100%)",
      zIndex: 1,
    },
    "& > *": {
      position: "relative",
      zIndex: 2,
    },
  },

  infoBox: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: whiteColor,
    baxShadow: "0 3px 4px rgb(229 233 240 / 22%)",
    padding: "8px 15px 8px 15px",
    border: logoImgborder1,
    borderRadius: "10px",
    marginTop: { xs: "10px", md: "15px" },
    overflow: "hidden",
  },
};
